'use client'

import Image from 'next/image'

import { Tooltip } from '~/components/component-library'
import { NetworkLogoViewProps } from '~/components/component-library/NetworkLogo/types'
import {
  chainIconMap,
  getChainBackgroundColor,
  getChainTextColor,
  iconVariants,
  sizeMap,
} from '~/components/component-library/NetworkLogo/util'
import { getChainLabel } from '~/utils/chainLabels'
import { cn } from '~/utils/tailwind-utils'

// Presentational single-logo view. Resolves nothing itself — NetworkLogo passes
// in the relay metadata — so it stays free of data fetching, mirroring
// TokenDisplay / TokenDisplayView.
export const NetworkLogoView = ({
  chainId,
  size,
  variant,
  relayNetworkInfo,
  className,
}: NetworkLogoViewProps) => {
  const ChainIcon = chainIconMap[chainId]

  const iconClasses = cn(
    iconVariants({ size }),
    getChainBackgroundColor(chainId),
  )

  let iconContent: React.ReactNode

  if (ChainIcon) {
    iconContent = (
      <div className="flex h-full w-full items-center justify-center bg-surface">
        <div className={iconClasses}>
          <ChainIcon
            size={sizeMap[size]}
            className={cn(getChainTextColor(chainId))}
          />
        </div>
      </div>
    )
  } else if (relayNetworkInfo) {
    iconContent = (
      <Image
        src={relayNetworkInfo.iconUrl}
        alt={`${relayNetworkInfo.displayName} logo`}
        width={sizeMap[size]}
        height={sizeMap[size]}
      />
    )
  } else {
    iconContent = (
      <div className="flex h-full w-full items-center justify-center text-xs text-secondary">
        ?
      </div>
    )
  }

  if (variant === 'standalone') {
    return <div className={cn(iconClasses, className)}>{iconContent}</div>
  }

  return (
    <Tooltip
      content={
        <div>{getChainLabel(chainId, { relayNetwork: relayNetworkInfo })}</div>
      }
    >
      <div className="bg-surface">
        <div className={iconClasses}>{iconContent}</div>
      </div>
    </Tooltip>
  )
}
